import { render, staticRenderFns } from "./MemberOrderGoods.vue?vue&type=template&id=96bdd7ea&scoped=true&"
import script from "./MemberOrderGoods.vue?vue&type=script&lang=js&"
export * from "./MemberOrderGoods.vue?vue&type=script&lang=js&"
import style0 from "./MemberOrderGoods.vue?vue&type=style&index=0&id=96bdd7ea&lang=scss&scoped=true&"
import style1 from "./MemberOrderGoods.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96bdd7ea",
  null
  
)

export default component.exports